<template>
  <div>
    <pulse-loader :loading="loadingObject.loadingCodes" :color="$constants.LOADING_COLOR" class="text-center"/>

    <div v-if="!loadingObject.loadingCodes">
      <table class="table table-sm mt-0 table-hover">
        <tbody>
        <template v-for="(code, drugId, i) in records.rk" v-if="hasLink(code?.details)">
          <tr>
            <td class="m_w_350" :rowspan="+(Object.values(code?.details ?? {}).length ?? 1) + 1">{{
                code.drug?.title
              }}
            </td>
          </tr>
          <tr v-for="(link, id, ii) in (code?.details ?? {})">
            <td>
              <a :href="`https://uteka.ru/product/${link.suppliers_link_data}`"
                 target="_blank"><i
                class="icon-fa icon-fa-globe"/></a> {{ link.suppliers_link_data }}
            </td>
            <td>
              <UtekaStatistics v-if="(code.drug?.suppliers_prices ?? []).find((p) => p.detail_id === +id)"
                               :stats="(code.drug?.suppliers_prices ?? []).find((p) => p.detail_id === +id)"/>
            </td>
            <td>
              <CreateWatchTask :task="savedTasks[id]" :detailId="id" ref="watchTask_Uteka"/>
            </td>
            <td>
              <!--              <template v-if="i === 0 && hasLink(code.details)">-->
              <!--                <button class="btn btn-default" type="button">скопировать<br/>условия</button>-->
              <!--              </template>-->
            </td>
          </tr>
        </template>
        <tr>
          <td colspan="10"><strong>Коды для справочной 003</strong></td>
        </tr>
        <tr>
          <td :rowspan="records['003sm'].length + 2">{{ drug?.title }}</td>
        </tr>
        <tr v-for="code in records['003sm']">
          <td>
            <a :href="`https://uteka.ru/product/${code.value}`"
               target="_blank"><i
              class="icon-fa icon-fa-globe"/></a> {{ code.value }}
          </td>
          <td></td>
          <td>
            <CreateWatchTask :task="savedTasks[code.id]" :detailId="code.id" detail-type="003" ref="watchTask_Uteka"/>
          </td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td>
            <Create003WatchTask :task="savedTasks[drug.id]" ref="watchTask_003"/>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import CreateWatchTask from "@/views/statistics/components/tasksType/CreateWatchTask.vue";
import UtekaStatistics from "@/components/suppliers/UtekaStatistics.vue";
import Create003WatchTask from "@/views/statistics/components/tasksType/Create003WatchTask.vue";
import {customUpdateData} from "@/eventsBus";

export default {
  components: {Create003WatchTask, UtekaStatistics, CreateWatchTask},
  props: ['drug', 'taskData'],
  data() {
    return {
      loadingObject: {
        loadingCodes: true,
      },
      records: {},
      customData: {
        period: false,
        frequency: false,
        report: false,
      },
      savedTasks: {},
      selected: {
        period: 10,
        frequency: 1,
        report: 1
      }
    }
  },
  async mounted() {
    await this.getActiveTasks();
    await this.getCodes();
    customUpdateData.$on(
      "updateMSPairedDrugs",
      async (data = {}) => {
        await this.getCodes(true);
      });
  },
  methods: {
    validate() {
      let error = false;
      const tasks = (this.$refs['watchTask_Uteka'] ?? []).reduce((acc, t) => {
        const conditions = t.conditions;
        const toDelete = t.toDelete;
        const interval = conditions.find((c) => !c.condition && +c.value);
        // console.log(conditions, interval);
        if (!toDelete && !conditions.find((c) => c.alias !== 'interval' && +c.value)) return acc;
        if (!toDelete && !interval && conditions.find((c) => c.condition && +c.value)) {
          error = true;
        }
        if (toDelete || (!error && interval)) {
          error = !toDelete && !conditions.find((c) => (c.condition && +c.value));
          if (!error) acc.push({
            toDelete,
            task_id: t.task?.id,
            detail_id: t.detailId,
            conditions: conditions,
            // conditions: conditions.map((c) => {
            //   return {
            //     alias: c.alias,
            //     condition: c.condition,
            //     value: c.value,
            //     target: c.target,
            //     joinCondition: c.joinCondition
            //   }
            // }),
            type: t.detailType ?? 'drug',
            'supplier': 'uteka'
          });
        }
        // console.log(error);
        return acc;
      }, [])
      // console.log(error);
      if (error) return {
        success: false,
        message: 'Данные для мониторинга не корректные'
      };
      const task = this.$refs.watchTask_003.conditions;
      const joinCondition = this.$refs.watchTask_003.joinCondition;
      const toDelete = this.$refs.watchTask_003.toDelete;
      if (toDelete || task.find((c) => c.value)) {
        tasks.push({
          toDelete,
          task_id: this.$refs.watchTask_003?.task?.id,
          conditions: task.map((t) => {
            return {...t, joinCondition: joinCondition}
          }),
          detail_id: this.drug.id,
          type: '003',
          'supplier': '003'
        })
      }
      // console.log(tasks);
      if (!tasks.length) return {
        success: false,
        message: 'Нет активных условий'
      }
      return {
        success: true, data: tasks
      };
    },
    async getActiveTasks() {
      const {data} = await api.index('/tasks/sm/' + this.drug.id);
      if (data.success) {
        this.savedTasks = data.tasks.reduce((acc, t) => {
          acc[t.detail_id] = t;
          return acc;
        }, {});
      }
    },
    async getCodes(silent = false) {
      this.loadingObject.loadingCodes = !silent;
      const {data} = await api.post('/new/drugs/infoType', {
        types: ['utekaCodesStats', 'uteka003CodesStats'],
        drug_type: '003',
        drug_id: this.drug.id,
      });
      if (data.success) {
        this.records = {rk: data.records, '003sm': data['003_records']};
      }
      this.loadingObject.loadingCodes = false;
    },
    updateFigures() {
      Object.keys(this.selected).forEach((k) => {
        if (+this.selected[k] === -1) {
          this.customData[k] = true;
          this.selected[k] = 10;
        }
      })
    },
    hasLink(details) {
      return Object.values(details ?? []).find((d) => d.suppliers_link_data);
    }
  }
}

</script>

<style scoped>
.m_w_350 {
  max-width: 350px;
}
</style>
